import { CanvasJSON } from '@doer/frontend-components/creativity-editor';
import { ESPN_HEROS_BASE_URL } from '../urls';

export const espnHero1920x2400: CanvasJSON = {
  version: '7.1.0',
  objects: [
    {
      cropX: 0,
      cropY: 0,
      pieceId: 'background',
      type: 'Image',
      version: '7.1.0',
      originX: 'center',
      originY: 'center',
      left: 960,
      top: 1200,
      width: 1920,
      height: 2400,
      fill: 'rgb(0,0,0)',
      stroke: null,
      strokeWidth: 0,
      strokeDashArray: null,
      strokeLineCap: 'butt',
      strokeDashOffset: 0,
      strokeLineJoin: 'miter',
      strokeUniform: false,
      strokeMiterLimit: 4,
      scaleX: 1,
      scaleY: 1,
      angle: 0,
      flipX: false,
      flipY: false,
      opacity: 1,
      shadow: null,
      visible: true,
      backgroundColor: '',
      fillRule: 'nonzero',
      paintFirst: 'fill',
      globalCompositeOperation: 'source-over',
      skewX: 0,
      skewY: 0,
      src: `${ESPN_HEROS_BASE_URL}/ligue1/backgrounds/1920x2400.png`,
      crossOrigin: 'anonymous',
      filters: [],
      selectable: false,
      evented: false
    },
    {
      cropX: 0,
      cropY: 0,
      pieceId: 'player-0',
      type: 'Image',
      version: '7.1.0',
      originX: 'center',
      originY: 'center',
      left: 323.8867,
      top: 1370.6354,
      width: 2048,
      height: 2048,
      fill: 'rgb(0,0,0)',
      stroke: null,
      strokeWidth: 0,
      strokeDashArray: null,
      strokeLineCap: 'butt',
      strokeDashOffset: 0,
      strokeLineJoin: 'miter',
      strokeUniform: false,
      strokeMiterLimit: 4,
      scaleX: 1.0052,
      scaleY: 1.0052,
      angle: 0,
      flipX: false,
      flipY: false,
      opacity: 1,
      shadow: null,
      visible: true,
      backgroundColor: '',
      fillRule: 'nonzero',
      paintFirst: 'fill',
      globalCompositeOperation: 'source-over',
      skewX: 0,
      skewY: 0,
      src: `${ESPN_HEROS_BASE_URL}/ligue1/as-monaco/ansu-fati/ansu-fati-002.png`,
      crossOrigin: 'anonymous',
      filters: []
    },
    {
      cropX: 0,
      cropY: 0,
      pieceId: 'player-3',
      type: 'Image',
      version: '7.1.0',
      originX: 'center',
      originY: 'center',
      left: 1584.6255,
      top: 1369.3295,
      width: 2048,
      height: 2048,
      fill: 'rgb(0,0,0)',
      stroke: null,
      strokeWidth: 0,
      strokeDashArray: null,
      strokeLineCap: 'butt',
      strokeDashOffset: 0,
      strokeLineJoin: 'miter',
      strokeUniform: false,
      strokeMiterLimit: 4,
      scaleX: 1.0065,
      scaleY: 1.0065,
      angle: 0,
      flipX: false,
      flipY: false,
      opacity: 1,
      shadow: null,
      visible: true,
      backgroundColor: '',
      fillRule: 'nonzero',
      paintFirst: 'fill',
      globalCompositeOperation: 'source-over',
      skewX: 0,
      skewY: 0,
      src: `${ESPN_HEROS_BASE_URL}/ligue1/auxerre/francisco-sierralta/francisco-sierralta-002.png`,
      crossOrigin: 'anonymous',
      filters: []
    },
    {
      cropX: 0,
      cropY: 0,
      pieceId: 'player-2',
      type: 'Image',
      version: '7.1.0',
      originX: 'center',
      originY: 'center',
      left: 1173.8,
      top: 1366.1801,
      width: 2048,
      height: 2048,
      fill: 'rgb(0,0,0)',
      stroke: null,
      strokeWidth: 0,
      strokeDashArray: null,
      strokeLineCap: 'butt',
      strokeDashOffset: 0,
      strokeLineJoin: 'miter',
      strokeUniform: false,
      strokeMiterLimit: 4,
      scaleX: 1.0096,
      scaleY: 1.0096,
      angle: 0,
      flipX: false,
      flipY: false,
      opacity: 1,
      shadow: null,
      visible: true,
      backgroundColor: '',
      fillRule: 'nonzero',
      paintFirst: 'fill',
      globalCompositeOperation: 'source-over',
      skewX: 0,
      skewY: 0,
      src: `${ESPN_HEROS_BASE_URL}/ligue1/auxerre/diomande-sinaly/diomande-sinaly-005.png`,
      crossOrigin: 'anonymous',
      filters: []
    },
    {
      cropX: 0,
      cropY: 0,
      pieceId: 'player-1',
      type: 'Image',
      version: '7.1.0',
      originX: 'center',
      originY: 'center',
      left: 747.4003,
      top: 1362.6101,
      width: 2048,
      height: 2048,
      fill: 'rgb(0,0,0)',
      stroke: null,
      strokeWidth: 0,
      strokeDashArray: null,
      strokeLineCap: 'butt',
      strokeDashOffset: 0,
      strokeLineJoin: 'miter',
      strokeUniform: false,
      strokeMiterLimit: 4,
      scaleX: 1.0131,
      scaleY: 1.0131,
      angle: 0,
      flipX: false,
      flipY: false,
      opacity: 1,
      shadow: null,
      visible: true,
      backgroundColor: '',
      fillRule: 'nonzero',
      paintFirst: 'fill',
      globalCompositeOperation: 'source-over',
      skewX: 0,
      skewY: 0,
      src: `${ESPN_HEROS_BASE_URL}/ligue1/as-monaco/golovin-aleksandr/golovin-aleksandr-004.png`,
      crossOrigin: 'anonymous',
      filters: []
    }
  ],
  background: '#f0f0f0'
};
